import {
  string as yupString,
  ref as yupRef,
} from 'yup';
import { translate } from '../../locales/i18n';

const userNameValidation = yupString()
  .min(2, (opts) => translate('validation_user_name_short', opts))
  // FIXME(clairbee): starts uppercase
  // FIXME(clairbee): not all caps
  .required(() => translate('validation_user_name_required'));

const userDescValidation = yupString()
  .min(32, (opts) => translate('validation_user_about_short', opts))
  // FIXME(clairbee): starts uppercase
  // FIXME(clairbee): not all caps
  .required(() => translate('validation_user_about_required'));
  // .nullable();

const usernameValidation = yupString()
  .min(4, (opts) => translate('validation_username_short', opts))
  .required(() => translate('validation_email_required'));

const emailValidation = yupString()
  .email(() => translate('validation_email_wrong'))
  .required(() => translate('validation_email_required'));

const passwordValidation = yupString()
  .min(8, (opts) => translate('validation_password_min', opts))
  .matches(/[0-9]/, () => translate('validation_password_digits'))
  .matches(/[a-z]/, () => translate('validation_password_lowercase'))
  .matches(/[A-Z]/, () => translate('validation_password_uppercase'))
  .required(() => translate('validation_password_required'));

const password2Validation = yupString()
  .oneOf([yupRef('password'), null], () => translate('validation_password2_mismatch'))
  .required(() => translate('validation_password2_required'));

const codeValidation = yupString()
  .min(6, (_opts) => translate('validation_code_wrong'))
  .max(6, (_opts) => translate('validation_code_wrong'))
  .matches(/[0-9]{6}/, (_opts) => translate('validation_code_wrong'))
  .required(() => translate('validation_code_required'));

export {
  userNameValidation,
  userDescValidation,
  usernameValidation,
  emailValidation,
  passwordValidation,
  password2Validation,
  codeValidation,
};
